// Generated by purs version 0.15.0
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Reader_Trans from "../Control.Monad.Reader.Trans/index.js";
import * as Control_Monad_Trans_Class from "../Control.Monad.Trans.Class/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Specular_Internal_Effect from "../Specular.Internal.Effect/index.js";
var CleanupT = function (x) {
    return x;
};
var runCleanupT = function (dictMonadEffect) {
    return function (v) {
        return Control_Bind.bind((dictMonadEffect.Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadEffect)(Specular_Internal_Effect.emptyDelayed))(function (actionsMutable) {
            return Control_Bind.bind((dictMonadEffect.Monad0()).Bind1())(Control_Monad_Reader_Trans.runReaderT(v)(actionsMutable))(function (result) {
                return Control_Bind.bind((dictMonadEffect.Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadEffect)(Specular_Internal_Effect.unsafeFreezeDelayed(actionsMutable)))(function (actions) {
                    return Control_Applicative.pure((dictMonadEffect.Monad0()).Applicative0())(new Data_Tuple.Tuple(result, Specular_Internal_Effect.sequenceEffects(actions)));
                });
            });
        });
    };
};
var onCleanup = function (dict) {
    return dict.onCleanup;
};
var monadTransCleanupT = {
    lift: function (dictMonad) {
        var $14 = Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(dictMonad);
        return function ($15) {
            return CleanupT($14($15));
        };
    }
};
var monadEffectCleanupT = function (dictMonadEffect) {
    return Control_Monad_Reader_Trans.monadEffectReader(dictMonadEffect);
};
var monadCleanupT = function (dictMonad) {
    return Control_Monad_Reader_Trans.monadReaderT(dictMonad);
};
var monadCleanupReaderT = function (dictMonadCleanup) {
    return {
        onCleanup: (function () {
            var $16 = Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT)(dictMonadCleanup.Monad0());
            var $17 = onCleanup(dictMonadCleanup);
            return function ($18) {
                return $16($17($18));
            };
        })(),
        Monad0: function () {
            return Control_Monad_Reader_Trans.monadReaderT(dictMonadCleanup.Monad0());
        }
    };
};
var monadCleanupCleanupT = function (dictMonadEffect) {
    return {
        onCleanup: function (action) {
            return function (actions) {
                return Effect_Class.liftEffect(dictMonadEffect)(Specular_Internal_Effect.pushDelayed(actions)(action));
            };
        },
        Monad0: function () {
            return monadCleanupT(dictMonadEffect.Monad0());
        }
    };
};
var functorCleanupT = function (dictFunctor) {
    return Control_Monad_Reader_Trans.functorReaderT(dictFunctor);
};
var execCleanupT = function (dictMonadEffect) {
    var $19 = Data_Functor.map((((dictMonadEffect.Monad0()).Bind1()).Apply0()).Functor0())(Data_Tuple.snd);
    var $20 = runCleanupT(dictMonadEffect);
    return function ($21) {
        return $19($20($21));
    };
};
var bindCleanupT = function (dictBind) {
    return Control_Monad_Reader_Trans.bindReaderT(dictBind);
};
var applyCleanupT = function (dictApply) {
    return Control_Monad_Reader_Trans.applyReaderT(dictApply);
};
var applicativeCleanupT = function (dictApplicative) {
    return Control_Monad_Reader_Trans.applicativeReaderT(dictApplicative);
};
export {
    onCleanup,
    CleanupT,
    runCleanupT,
    execCleanupT,
    functorCleanupT,
    applyCleanupT,
    applicativeCleanupT,
    bindCleanupT,
    monadCleanupT,
    monadEffectCleanupT,
    monadTransCleanupT,
    monadCleanupCleanupT,
    monadCleanupReaderT
};
//# sourceMappingURL=index.js.map
